import React from 'react';
import { Link } from 'react-router-dom';
import { FaTrash } from 'react-icons/fa'; // Import the trash icon for deletion
import { db } from '../firebase';
import { doc, deleteDoc, collection, getDocs, query, orderBy } from 'firebase/firestore';

function ApplicationsTable({ applications, isLoading, setApplications }) {

  // Function to delete an application and refetch data
  const deleteApplication = async (id) => {
    // Confirmation before deleting
    const confirmDelete = window.confirm("Are you sure you want to delete this application?");
    if (confirmDelete) {
      try {
        await deleteDoc(doc(db, "applications", id)); // Delete the document from Firestore
        alert("Application deleted successfully.");

        // // Refetch the applications list after deletion
        // const q = query(collection(db, "applications"), orderBy("createdAt", "desc"));
        // const querySnapshot = await getDocs(q);
        // const appsList = querySnapshot.docs.map(doc => ({
        //   id: doc.id,
        //   ...doc.data(),
        // }));
        
        // setApplications(appsList); // Update the state with the new list of applications

        window.location.reload();
      } catch (error) {
        console.error("Error deleting application: ", error);
        alert("Failed to delete application.");
      }
    }
  };

  if (isLoading) {
    return (
      <div className="mt-6 flex justify-center p-12">
        <p className="text-text-color/70">Loading applications...</p>
      </div>
    );
  }

  if (applications.length === 0) {
    return (
      <div className="mt-6 flex justify-center p-12">
        <p className="text-text-color/70">No applications found.</p>
      </div>
    );
  }

  const desktopTable = (
    <div className="hidden md:block overflow-hidden">
      <table className="w-full table-fixed text-left border-collapse">
        <thead className="border-b border-border-color">
          <tr>
            <th className="p-2 md:p-4 text-sm font-semibold text-text-color/70 w-[10%]">MDRO No</th>
            <th className="p-2 md:p-4 text-sm font-semibold text-text-color/70 w-[10%]">Lease Name</th>
            <th className="p-2 md:p-4 text-sm font-semibold text-text-color/70 w-[10%]">Lease No</th>
            {/* <th className="p-2 md:p-4 text-sm font-semibold text-text-color/70 w-[15%]">Submission Date</th> */}
            <th className="p-2 md:p-4 text-sm font-semibold text-text-color/70 w-[10%]">Action</th>
          </tr>
        </thead>
        <tbody>
          {applications.map((app) => (
            <tr key={app.id} className="border-b border-border-color last:border-b-0">
              <td className="p-2 md:p-4 text-sm font-medium text-text-color break-words">{app.mdroNo}</td>
              <td className="p-2 md:p-4 text-sm text-text-color/80 break-words">{app.leaseName}</td>
              <td className="p-2 md:p-4 text-sm text-text-color/80 break-words">{app.leaseNo}</td>
              {/* <td className="p-2 md:p-4 text-sm text-text-color/80 break-words">
                {app.createdAt ? new Date(app.createdAt.seconds * 1000).toLocaleDateString() : 'N/A'}
              </td> */}
              <td className="p-2 md:p-4 text-sm align-middle w-[50%]">
                <div className="inline-block max-w-full truncate">
                  <Link
                    to={`/application/${app.mdroNo}`}
                    className="text-sm font-bold text-primary hover:underline break-words text-left"
                  >
                    View
                  </Link>
                  {/* Delete button */}
                  <button
                    onClick={() => deleteApplication(app.id)} // Pass the app id to delete function
                    className="ml-2 text-red-500 hover:text-red-700"
                    aria-label="Delete application"
                  >
                    <FaTrash />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  const mobileCards = (
    <div className="flex flex-col gap-3 md:hidden">
      {applications.map((app) => (
        <div
          key={app.id}
          className="flex flex-col rounded-lg border border-border-color bg-white p-3 text-sm shadow-sm"
        >
          <div className="flex justify-between items-start">
            <p className="font-medium text-text-color">{app.leaseName}</p>
            <Link
              to={`/application/${app.mdroNo}`}
              className="text-primary font-semibold hover:underline whitespace-nowrap"
            >
              View
            </Link>
            {/* Delete button */}
            <button
              onClick={() => deleteApplication(app.id)} // Pass the app id to delete function
              className="text-red-500 hover:text-red-700"
              aria-label="Delete application"
            >
              <FaTrash />
            </button>
          </div>
          <div className="mt-2 text-text-color/80 space-y-1">
            <p><span className="font-semibold">MDRO No:</span> {app.mdroNo}</p>
            <p><span className="font-semibold">Lease No:</span> {app.leaseNo}</p>
            <p><span className="font-semibold">Date:</span> 
              {app.createdAt ? new Date(app.createdAt.seconds * 1000).toLocaleDateString() : 'N/A'}
            </p>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="mt-6 flex flex-col gap-4 rounded-xl border border-border-color bg-input-bg/95 p-4">
      <div className="flex flex-col">
        <p className="text-lg font-medium leading-normal text-header-text">All Applications</p>
        <p className="text-sm text-text-color/70">List of all submitted applications.</p>
      </div>
      {desktopTable}
      {mobileCards}
    </div>
  );
}

export default ApplicationsTable;
